





























import * as _ from 'lodash';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';

import UiCheckbox from '../ui/UiCheckbox.vue';
import UiSelect2 from '../ui/UiSelect2.vue';
import UiTextEdit from '../ui/UiTextEdit.vue';

@Component({
  components: {
    UiTextEdit,
    UiSelect2,
    UiCheckbox,
  },
})
export default class BlockchainAddressInput extends BaseVue {
  public xApiKey = '';
  public subAccountName = '';
  public exchangeContactId = '';
  public useFppsDayEarned = false;
  public isValid = false;

  public debouncedValidate = _.debounce(this.validateForm.bind(this), 200);

  public async validateForm() {
    this.isValid = !!this.xApiKey && !!this.subAccountName && !!this.exchangeContactId;
  }

  public get contacts() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    const res: any = {};
    contacts.forEach((contact: any) => (res[contact.name] = contact.id));
    return res;
  }

  public get contactsArray() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    return contacts.map((contact: any) => ({ id: contact.id, label: contact.name }));
  }

  @Watch('xApiKey')
  @Watch('subAccountName')
  @Watch('exchangeContactId')
  @Watch('useFppsDayEarned')
  public onWalletTypeChanged() {
    this.debouncedValidate();
    this.$emit('data', {
      createFoundry: {
        xApiKey: this.xApiKey,
        subAccountName: this.subAccountName,
        exchangeContactId: this.exchangeContactId,
        flags: {
          useFppsDayEarned: this.useFppsDayEarned,
        },
      },
    });
    this.isValid = false;
  }

  @Watch('isValid')
  public validChanged() {
    this.$emit('valid', this.isValid);
  }
}
